import { AuthService } from './auth';

export class ImageUploadService {
  private baseUrl = '/api';
  constructor(private auth: AuthService) {}

  async uploadImage(file: File): Promise<string> {
    if (!this.validateImage(file)) {
      throw new Error('Invalid image file');
    }

    const formData = new FormData();
    formData.append('image', file);

    const authInit = this.auth.applyAuthHeader();

    const response = await fetch(`${this.baseUrl}/upload-image`, {
      method: 'POST',
      headers: authInit.headers,
      body: formData,
    });

    if (!response.ok) {
      if (response.status === 401) {
        await this.auth.handleUnauthorized();
        throw new Error('Unauthorized request');
      }
      const error = await response.json().catch(() => ({ error: 'Upload failed' })) as any;
      throw new Error(error.error || 'Failed to upload image');
    }

    const data = await response.json() as any;
    return data.url;
  }

  validateImage(file: File): boolean {
    const maxSize = 10 * 1024 * 1024; // 10MB
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

    if (file.size > maxSize) {
      return false;
    }

    if (!allowedTypes.includes(file.type)) {
      return false;
    }

    return true;
  }

  getImagePreviewUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target?.result) {
          resolve(e.target.result as string);
        } else {
          reject(new Error('Failed to read file'));
        }
      };
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsDataURL(file);
    });
  }
}
